import moment from 'moment';


const schedule2Event = (s) => {
  let color = "blue";
  const startTime = moment(s.startTime).format("hh:mm a")
  const endTime = moment(s.endTime).format("hh:mm a")

  const label = `${startTime} - ${endTime}`

  return {
    id: s.id,
    type: s.type,
    name: label,
    scheduleId: s.scheduleId,
    centerId: s.centerId,
    centerName: s.center,
    recurring: s.partOfRecurring ? true : false,
    start: moment(s.startTime).format("YYYY-MM-DD HH:mm"),
    end: moment(s.endTime).format("YYYY-MM-DD HH:mm"),
    date: moment(s.startTime).format("YYYY-MM-DD"),
    recurringEndDate: s.recurringEndDate,
    color,
  };
}

const roundOffTime = (time, roundOffMins = 5) => {
  let currentMoment = moment(time);
  let remainder = roundOffMins - (currentMoment.minute() % roundOffMins);
  if (remainder === roundOffMins) {
    remainder = 0;
  }
  return currentMoment.add(remainder, 'minutes').startOf('minute');
};

const generateDates = (schedules, today, endCondition, dateIncrementer, sortCondition, scheduleExclusionDates, isFuture) => {
  let dates = [];
  const dayLookup = {
    'Sun': 0,
    'Mon': 1,
    'Tue': 2,
    'Wed': 3,
    'Thu': 4,
    'Fri': 5,
    'Sat': 6,
  };

  for (let schedule of schedules) {
    const recurringDays = schedule.recurringDays.map(day => dayLookup[day]);

    let startDate, endDate;
    let currentDate = moment();

    if (schedule.recurring) {
      startDate = moment(schedule.startDate);
      endDate = schedule.recurringEndDate ? moment(schedule.recurringEndDate) : moment().add(100, 'years');
    } else {
      startDate = moment(schedule.startDate);
      endDate = moment(schedule.endDate);
    }

    if (schedule.recurring) {
      let date = today.clone();
      while (!recurringDays.includes(date.day())) {
        dateIncrementer(date);
      }

      while (endCondition(date)) {
        // console.log("Checking date:", date.format('YYYY-MM-DD hh:mm')); // Debugging information
        // console.log("Day of week:", date.format('dddd')); // Debugging information
        // console.log("Is same or after start date:", date.isSameOrAfter(startDate));
        // console.log("Is same or before end date:", date.isSameOrBefore(endDate));
        // console.log("end date:", endDate.format('YYYY-MM-DD hh:mm'));
        // console.log("Is recurring day:", recurringDays.includes(date.day()));

        if (date.startOf('day').isSameOrAfter(startDate.startOf('day')) && date.startOf('day').isSameOrBefore(endDate.startOf('day')) && recurringDays.includes(date.day())) {
          // console.log("Start Date:", startDate.format('YYYY-MM-DD'));
          // console.log("End Date:", endDate.format('YYYY-MM-DD'));
          // console.log("Recurring Days:", recurringDays);
          
          dates.push({
            date: date.format('YYYY-MM-DD'),
            schedule: schedule,
            excluded: scheduleExclusionDates.some(exclusion => exclusion.scheduleId === schedule.id && exclusion.date === date.format('YYYY-MM-DD'))
          });
        }
        dateIncrementer(date);
      }
    } else {
      const timeCondition = isFuture ? startDate.isSameOrAfter(currentDate) : startDate.isSameOrBefore(currentDate);
      if (timeCondition) {
        dates.push({
          date: startDate.format('YYYY-MM-DD'),
          schedule: schedule,
          excluded: scheduleExclusionDates.some(exclusion => exclusion.scheduleId === schedule.id && exclusion.date === startDate.format('YYYY-MM-DD'))
        });
      }    
    }
  }


  dates.sort((a, b) => moment(a.date).isAfter(moment(b.date)) ? sortCondition : -sortCondition);
  return dates;
};


const generateActiveDates = (schedules, scheduleExclusionDates = [], monthsRange = 1) => {
  const endCondition = (date) => date.isSameOrBefore(moment().add(monthsRange, 'month'));  const today = moment();
  const dateIncrementer = (date) => date.add(1, 'days');
  const sortCondition = 1;
  const isFuture = true;

  return generateDates(schedules, today, endCondition, dateIncrementer, sortCondition, scheduleExclusionDates, isFuture);
};

const generatePastDates = (schedules, scheduleExclusionDates = [], monthsRange = 1) => {
  const today = moment();
  const endCondition = (date) => date.isSameOrAfter(moment().subtract(monthsRange, 'month').startOf('day'));
  const dateIncrementer = (date) => date.subtract(1, 'days');
  const sortCondition = -1;
  const isFuture = false;

  return generateDates(schedules, today, endCondition, dateIncrementer, sortCondition, scheduleExclusionDates, isFuture);
};

const mapStudentSchedule = (schedule) => {
  return {
      id: schedule.scheduleId,
      teacherId: schedule.teacherId || schedule.tempTeacherId,
      classroomId: schedule.classroomId || schedule.tempClassroomId,
      studentFirstName: schedule.studentFirstName,
      studentLastName: schedule.studentLastName,
      studentId: schedule.studentId,
      startTime: schedule.startTime,
      endTime: schedule.endTime,
      partOfRecurring: schedule.partOfRecurring,
      recurringDays: schedule.recurringDays,
      recurringStartDate: schedule.recurringStartDate,
      recurringEndDate: schedule.recurringEndDate,
      programId: schedule.programId,
      centerId: schedule.centerId,
      notes: schedule.notes
  };
}



export {
  schedule2Event,
  roundOffTime,
  generateActiveDates,
  generatePastDates,
  mapStudentSchedule
}